import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Brands from '../components/Brands';
import About from '../components/About';
import Founder from '../components/Founder';
import Contact from '../components/Contact';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Hero onCta={() => scrollToSection('contact')} onSecondaryCta={() => scrollToSection('services')} />
      <Services />
      <Brands />
      <About />
      <Founder />
      <Contact />
    </>
  );
}
